<template>
  <div>
    <Head title="Barazimet me shitës"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/financat/barazimet-me-shites">Barazimet me
        shitës
      </Link>
      <span class="text-indigo-400 font-medium">/</span> Në pritje
    </h1>

    <div class="flex flex-wrap mx-2 mb-6 lg:mb-6">
      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="route('admin.finances.seller-barazimet.pending',{barazim_periodicity_type: 'daily'})">{{ this.businessesData.daily }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Çdo 24 orë</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5  mr-5 mt-2  w-full lg:w-1/6 bg-indigo-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="route('admin.finances.seller-barazimet.pending',{barazim_periodicity_type: 'weekly'})">{{ this.businessesData.weekly }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Një herë në javë</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-orange-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="route('admin.finances.seller-barazimet.pending',{barazim_periodicity_type: 'twice-weekly'})">{{ this.businessesData.twice_weekly }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Dy herë në javë</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-indigo-900 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="route('admin.finances.seller-barazimet.pending',{barazim_periodicity_type: 'twice-monthly'})">{{ this.businessesData.twice_monthly }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Çdo dy javë</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-yellow-700 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="route('admin.finances.seller-barazimet.pending',{barazim_periodicity_type: 'monthly'})">{{ this.businessesData.monthly }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Një herë në muaj</h1>
      </div>

      <div class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2 w-full lg:w-1/6 bg-green-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="route('admin.finances.seller-barazimet.pending',{barazim_periodicity_type: 'custom'})">{{ this.businessesData.custom }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Sipas dëshirës</h1>
      </div>

    </div>


    <div class="flex items-center mb-6">
      <h2 class="mt-12 text-2xl font-bold">Barazimet e skeduluara për sot
        <span v-if="this.pendingBarazims">({{this.sortedBarazims.length}})</span>
      </h2>
    </div>

    <div v-if="currentSelections != null && currentSelections.length !== 0" class="flex flex-wrap lg:flex-nowrap mb-6 lg:mb-3 items-center">
      <button class="btn-indigo mr-3" type="button" @click="registerMultipleBarazims">Regjistro</button>

    </div>

    <div v-if="this.pendingBarazims" class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">
            <input :checked="allSelected" @click="selectAll" class="flex items-center  px-2 py-4" type="checkbox">
          </th>
          <th class="pb-4 pt-6 px-2"></th>
          <th @click="sort('business_name')" class="pb-4 pt-6 px-2 cursor-pointer">Biznesi shitës</th>
          <th @click="sort('periodicity_type')" class="pb-4 pt-6 px-2 cursor-pointer">Perioda</th>
          <th  class="pb-4 pt-6 px-2">Ditët e javës</th>
          <th @click="sort('last_barazim_created_at')" class="pb-4 pt-6 px-2 cursor-pointer">Barazimi i fundit</th>
          <th @click="sort('total_sales')" class="pb-4 pt-6 px-2 cursor-pointer">Total shitje</th>
          <th @click="sort('total_shipping_cost')" class="pb-4 pt-6 px-2 cursor-pointer">Total posta</th>
          <th @click="sort('total_neto_amount')" class="pb-4 pt-6 px-2 cursor-pointer">Totali për dorëzim</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="barazim in sortedBarazims" :key="barazim.business_id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
        >

          <td class="border-t px-2">
            <input v-model="barazim.selected" :value="barazim.business_id" class="flex items-center  px-2 py-4" type="checkbox">
          </td>

          <td class="w-px border-t px-2">
            <Link :href="`/admin/financat/barazimet-me-shites/regjistro?business_id=${barazim.business_id}`"
                  class="flex items-center  px-2 py-4" tabindex="-1"
            >
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </Link>
          </td>

          <td class="border-t px-2">
            {{ barazim.business_name }}
          </td>
          <td class="border-t px-2">
            {{getHRPeriodicity(barazim.barazim_periodicity_type)}}
          </td>
          <td class="border-t px-2">
            {{ getHRWeekDays(barazim.barazim_periodicity_week_days ) }}
          </td>
          <td class="border-t px-2">
            {{ barazim.barazim_created_at }}
          </td>
          <td class="border-t px-2">
            {{ barazim.total_sales }}
          </td>
          <td class="border-t px-2">
            {{ barazim.total_shipping_cost }}
          </td>

          <td class="border-t px-2">
            {{ barazim.total_neto_amount }}
          </td>
        </tr>
        <tr v-if="pendingBarazims.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje barazim.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="p-20 overflow-hidden rounded-md shadow bg-white w-full content-center">
      <div role="status" class="flex justify-center">
        <svg aria-hidden="true" class="w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-indigo-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import Dropdown from '@/Shared/Dropdown'
import {computed} from 'vue'
import FileInput from '@/Shared/FileInput'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import Multiselect from '@vueform/multiselect'
import {Inertia} from '@inertiajs/inertia'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchInput,
    SearchFilter,
    Dropdown,
    FileInput,
    Modal,
    LoadingButton,
    SelectInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    pendingBarazims: Object,
    businessesData: Object,
  },
  mounted() {
    Inertia.reload({
      only: ['pendingBarazims'],
      onSuccess: function(data){
        data.props.pendingBarazims.forEach((barazim) => barazim['selected'] = false);
      }
    })
    // this.pendingBarazims.forEach((barazim) => barazim['selected'] = false);
  },
  computed: {
    allSelected(){
      return this.pendingBarazims.every(barazim => barazim.selected)
    },
    sortedBarazims(){
      return this.pendingBarazims.sort((a,b) => {
        if(this.currentSort == null) return 0;
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;

        if(!isNaN(a[this.currentSort])){
          if( parseFloat(a[this.currentSort]) < parseFloat(b[this.currentSort])) return -1 * modifier;
          if(parseFloat(a[this.currentSort]) > parseFloat(b[this.currentSort])) return modifier;
          return 0;
        }

        if((a[this.currentSort] != null ? a[this.currentSort].toLowerCase(): '') < (b[this.currentSort] != null ? b[this.currentSort].toLowerCase() : '')) return -1 * modifier;
        if((a[this.currentSort] != null ? a[this.currentSort].toLowerCase() : '') > (b[this.currentSort] != null ? b[this.currentSort].toLowerCase() : '')) return modifier;
        return 0;
      });
    }
  },
  data(){
    return {
      currentSelections: null,
      currentSort: null,
      currentSortDir: 'asc'
    }
  },
  watch: {
    pendingBarazims: {
      handler() {

        this.currentSelections = this.pendingBarazims
          .filter( barazim => barazim.selected )
          .map( barazim => barazim.business_id )
          .toString();
      },
      deep: true
    },
  },
  methods: {
    registerMultipleBarazims(){
      if(confirm('Keni selektuar ' + this.currentSelections.split(',').length + ' barazim(e). A jeni të sigurt se dëshironi të vazhdoni?')){
        this.$inertia.post('/admin/financat/barazimet-me-shites/multiple',{business_ids: this.currentSelections})
      }
    },
    selectAll(){
      let allS = this.allSelected;
      this.pendingBarazims.forEach(barazim => barazim.selected = !allS)
    },
    sort(sortBy) {
      if(sortBy === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = sortBy;
    },
    getHRWeekDays(weekDays){
      let hrWeekDays = '';

      let arr = JSON.parse(weekDays);
      if(arr){
        arr.forEach(function(weekDay, index){
          if(weekDay == 0)
            hrWeekDays += 'E diele ';

          if(weekDay == 1)
            hrWeekDays += 'E hënë ';

          if(weekDay == 2)
            hrWeekDays += 'E martë ';

          if(weekDay == 3)
            hrWeekDays += 'E mërkurë ';

          if(weekDay == 4)
            hrWeekDays += 'E enjte ';

          if(weekDay == 5)
            hrWeekDays += 'E premte ';

          if(weekDay == 6)
            hrWeekDays += 'E shtunë ';
        });
      }

      return hrWeekDays;
    },
    getHRPeriodicity(periodicityType){

      let hrPeriodicity = 'Sipas dëshirës';

      if(periodicityType === 'daily'){
        hrPeriodicity = 'Çdo 24 orë';
      }

      if(periodicityType === 'weekly'){
        hrPeriodicity = 'Një herë në javë';
      }

      if(periodicityType === 'twice-weekly'){
        hrPeriodicity = 'Dy herë në javë';
      }

      if(periodicityType === 'twice-monthly'){
        hrPeriodicity = 'Çdo dy javë';
      }

      if(periodicityType === 'monthly'){
        hrPeriodicity = 'Një herë në muaj';
      }

      return hrPeriodicity;
    }
  }
}
</script>

<style scoped>

</style>
